export default __webpack_public_path__ + "static/area-with-negative-values-cbea8151dc9f0760adaa8b13c8942dd5.png";